module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNDQUNGQ0QiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTguNDU2LjMyMmwxLjcxNCA0Ljk4NSA1LjM1My4wNjFjLjQ2MS4wMDUuNjUyLjU4Mi4yODIuODUyTDExLjUxIDkuMzYybDEuNTk1IDUuMDIyYy4xMzcuNDMyLS4zNjEuNzg5LS43MzcuNTI3TDggMTEuODY3IDMuNjMyIDE0LjkxYy0uMzc1LjI2Mi0uODc0LS4wOTUtLjczNy0uNTI2TDQuNDkgOS4zNi4xOTUgNi4yMmMtLjM3LS4yNy0uMTc5LS44NDcuMjgyLS44NTNsNS4zNTMtLjA2TDcuNTQ0LjMyYy4xNDgtLjQyOC43NjUtLjQyOC45MTIuMDAxeiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/evaluation/star_gray.svg
// module id = 7p2E
// module chunks = 30